export default {
  label: {
    series: {
      openTickets: 'Open Tickets',
      closedTickets: 'Closed Tickets',
    },
  },
};
